import { createContext } from "react";
const UserAuth = {
    userAuthToken: "",
    setUserAuthToken: () => { },
};

export const AppAuth = createContext(
    UserAuth
);